import { render, staticRenderFns } from "./ClinicUsers.vue?vue&type=template&id=1309e10a"
import script from "./ClinicUsers.vue?vue&type=script&lang=js"
export * from "./ClinicUsers.vue?vue&type=script&lang=js"
import style0 from "./ClinicUsers.vue?vue&type=style&index=0&id=1309e10a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports